// These are the rules by which the form input fields will be checked against.

import { getValue, isYoutube } from "../shared/miscUtils";
import { formHasErrors, formHasValue, setFormValues } from "./objectValidation";

/**
 * Criteria:
 * 1) Required if URL not about YouTube
 */
const nameValidation = (prevConfig, row, value) => {
    const url = getValue(row, "url");

    // 1)
    if (!isYoutube(url) && value.trim() === "") {
        return setFormValues(row, "name", true, "Required");
    }

    return setFormValues(row, "name", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) Must be a valid url
 */
const urlValidation = (prevConfig, row, value) => {
    // 1)
    if (value === "") {
        return setFormValues(row, "url", true, "Required");
    }

    // 2)
    if (!/^(http|https):\/\/[^ "]+$/.test(value)) {
        return setFormValues(row, "url", true, "Invalid URL");
    }

    return setFormValues(row, "url", false, "");
};

// The main constant, directing to the specific validation function.
export const LIBRARY_VALIDATION = {
    name: {
        check: nameValidation
    },
    url: {
        check: urlValidation
    }
};

export const IS_LIBRARY_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "url");
};
